import * as actionTypes from '../types/pieceInfo';

const initialState = {
  loading: false,
  details: null
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_PIECE_DETAILS:
      return {
        ...state,
        loading: true
      };
    case actionTypes.GET_PIECE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        details: payload
      };
    case actionTypes.GET_PIECE_DETAILS_FAIL:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

export default reducer;
